/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".style-1[_ngcontent-%COMP%]     .mat-form-field-wrapper{padding-bottom:0!important}"];
export { styles as styles };
